<template>
  <div class="app">
    <!-- 移动端菜单按钮 -->
    <div class="mobile-menu-btn" @click="toggleMobileMenu" v-if="isMobile">
      <Icon icon="heroicons:bars-3" width="24" height="24" />
    </div>

    <!-- 侧边栏遮罩 -->
    <div class="sidebar-mask" :class="{ 'show': mobileMenuOpen }" @click="closeMobileMenu"></div>

    <!-- 侧边栏 -->
    <aside class="sidebar" :class="{ 'collapsed': isCollapse, 'mobile-open': mobileMenuOpen }">
      <div class="sidebar-header">
        <div class="logo-area">
          <div class="logo-icon" v-if="!shopLogo">
            <Icon icon="carbon:ai-status" width="32" height="32" />
          </div>
          <img v-else :src="shopLogo" alt="商户端" class="logo-img" />
          <h1 class="logo-text" v-if="!isCollapse">{{ shopName }}</h1>
        </div>
        <button class="collapse-btn" @click="toggleCollapse" v-if="!isMobile">
          <Icon :icon="isCollapse ? 'heroicons:bars-3-20-solid' : 'heroicons:bars-3-20-solid'" width="20" height="20" />
        </button>
      </div>

      <div class="nav-container">
        <nav class="nav-menu">
          <!-- 控制台 -->
          <router-link to="/dashboard" class="nav-item" :class="{ 'active': activeMenu === '/dashboard' }">
            <Icon icon="heroicons:home" width="20" height="20" class="nav-icon" />
            <span class="nav-text" v-if="!isCollapse">控制台</span>
          </router-link>

          <!-- 账号管理 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('account')" @mouseleave="handleMouseLeave('account')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('account')">
              <Icon icon="heroicons:users" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">账号管理</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('account') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu"
              :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'account' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'account' : expandedMenus.includes('account')">
              <router-link to="/account/category" class="sub-item">
                <Icon icon="heroicons:tag" width="18" height="18" />
                <span>账号分组</span>
              </router-link>
              <router-link to="/account/account" class="sub-item">
                <Icon icon="heroicons:user-group" width="18" height="18" />
                <span>授权账号</span>
              </router-link>
            </div>
          </div>

          <!-- SEO配置 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('seo')" @mouseleave="handleMouseLeave('seo')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('seo')">
              <Icon icon="heroicons:chart-bar" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">SEO配置</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('seo') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu" :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'seo' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'seo' : expandedMenus.includes('seo')">
              <router-link to="/seoconfig/title" class="sub-item">
                <Icon icon="heroicons:pencil" width="18" height="18" />
                <span>标题管理</span>
              </router-link>
              <router-link to="/seoconfig/desc" class="sub-item">
                <Icon icon="heroicons:document-text" width="18" height="18" />
                <span>描述管理</span>
              </router-link>
              <router-link to="/seoconfig/topic" class="sub-item">
                <Icon icon="heroicons:hashtag" width="18" height="18" />
                <span>话题管理</span>
              </router-link>
            </div>
          </div>

          <!-- AI数字人 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('ai-human')" @mouseleave="handleMouseLeave('ai-human')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('ai-human')">
              <Icon icon="carbon:ai" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">AI数字人</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('ai-human') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu"
              :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'ai-human' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'ai-human' : expandedMenus.includes('ai-human')">
              <router-link to="/human_clone/humanclone" class="sub-item">
                <Icon icon="carbon:user-avatar" width="18" height="18" />
                <span>形象克隆</span>
              </router-link>
              <router-link to="/human_clone/humanrecord" class="sub-item">
                <Icon icon="heroicons:video-camera" width="18" height="18" />
                <span>视频合成</span>
              </router-link>
            </div>
          </div>

          <!-- 声音克隆 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('voice')" @mouseleave="handleMouseLeave('voice')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('voice')">
              <Icon icon="heroicons:microphone" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">声音克隆</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('voice') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu" :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'voice' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'voice' : expandedMenus.includes('voice')">
              <router-link to="/vocie_clone/VoiceClone" class="sub-item">
                <Icon icon="heroicons:microphone" width="18" height="18" />
                <span>声音克隆</span>
              </router-link>
              <router-link to="/vocie_clone/VoiceRecord" class="sub-item">
                <Icon icon="heroicons:speaker-wave" width="18" height="18" />
                <span>声音合成</span>
              </router-link>
            </div>
          </div>

          <!-- 视频剪辑 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('video-cut')" @mouseleave="handleMouseLeave('video-cut')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('video-cut')">
              <Icon icon="heroicons:film" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">视频剪辑</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('video-cut') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu"
              :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'video-cut' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'video-cut' : expandedMenus.includes('video-cut')">
              <router-link to="/videocut/video-cut" class="sub-item">
                <Icon icon="heroicons:sparkles" width="18" height="18" />
                <span>一键成片</span>
              </router-link>
              <router-link to="/videocut/wen-an" class="sub-item">
                <Icon icon="heroicons:document" width="18" height="18" />
                <span>文案管理</span>
              </router-link>
              <router-link to="/videocut/video-cp" class="sub-item">
                <Icon icon="heroicons:play" width="18" height="18" />
                <span>成片管理</span>
              </router-link>
              <router-link to="/videocut/video-wall" class="sub-item">
                <Icon icon="heroicons:view-columns" width="18" height="18" />
                <span>成片列表</span>
              </router-link>
            </div>
          </div>

          <!-- 视频发布 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('video-publish')"
            @mouseleave="handleMouseLeave('video-publish')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('video-publish')">
              <Icon icon="heroicons:share" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">视频发布</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('video-publish') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu"
              :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'video-publish' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'video-publish' : expandedMenus.includes('video-publish')">
              <router-link to="/video_publish/draft" class="sub-item">
                <Icon icon="heroicons:document-duplicate" width="18" height="18" />
                <span>发布任务</span>
              </router-link>
              <router-link to="/video_publish/record" class="sub-item">
                <Icon icon="heroicons:clock" width="18" height="18" />
                <span>发布记录</span>
              </router-link>
            </div>
          </div>

          <!-- 图文发布 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('tw-publish')"
            @mouseleave="handleMouseLeave('tw-publish')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('tw-publish')">
              <Icon icon="heroicons:newspaper" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">图文发布</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('tw-publish') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu"
              :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'tw-publish' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'tw-publish' : expandedMenus.includes('tw-publish')">
              <router-link to="/tw_publish/draft" class="sub-item">
                <Icon icon="heroicons:document-duplicate" width="18" height="18" />
                <span>发布任务</span>
              </router-link>
              <router-link to="/tw_publish/record" class="sub-item">
                <Icon icon="heroicons:clock" width="18" height="18" />
                <span>发布记录</span>
              </router-link>
            </div>
          </div>

          <!-- 挂载管理 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('mounting')" @mouseleave="handleMouseLeave('mounting')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('mounting')">
              <Icon icon="heroicons:link" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">挂载管理</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('mounting') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu"
              :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'mounting' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'mounting' : expandedMenus.includes('mounting')">
              <router-link to="/mounting/shop-gz" class="sub-item">
                <Icon icon="heroicons:shopping-bag" width="18" height="18" />
                <span>商品挂载</span>
              </router-link>
              <router-link to="/mounting/poi-gz" class="sub-item">
                <Icon icon="heroicons:map-pin" width="18" height="18" />
                <span>地址挂载</span>
              </router-link>
              <router-link to="/mounting/mini-gz" class="sub-item">
                <Icon icon="heroicons:device-phone-mobile" width="18" height="18" />
                <span>程序挂载</span>
              </router-link>
            </div>
          </div>

          <!-- 素材管理 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('material')" @mouseleave="handleMouseLeave('material')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('material')">
              <Icon icon="heroicons:photo" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">素材管理</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('material') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu"
              :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'material' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'material' : expandedMenus.includes('material')">
              <router-link to="/material/gallery" class="sub-item">
                <Icon icon="heroicons:photo" width="18" height="18" />
                <span>图库管理</span>
              </router-link>
              <router-link to="/material/video-sc" class="sub-item">
                <Icon icon="heroicons:film" width="18" height="18" />
                <span>视频管理</span>
              </router-link>
            </div>
          </div>

          <!-- 系统配置 -->
          <div class="nav-sub" @mouseenter="handleMouseEnter('system')" @mouseleave="handleMouseLeave('system')">
            <div class="nav-item sub-trigger" @click="toggleSubMenu('system')">
              <Icon icon="heroicons:cog-6-tooth" width="20" height="20" class="nav-icon" />
              <span class="nav-text" v-if="!isCollapse">系统配置</span>
              <Icon v-if="!isCollapse"
                :icon="expandedMenus.includes('system') ? 'heroicons:chevron-up-20-solid' : 'heroicons:chevron-down-20-solid'"
                width="16" height="16" class="sub-arrow" />
            </div>
            <div class="sub-menu" :class="{ 'collapsed-sub': isCollapse, 'show': hoverMenu === 'system' && isCollapse }"
              v-show="isCollapse ? hoverMenu === 'system' : expandedMenus.includes('system')">
              <router-link v-if="moduleStatus.writing_model === 2" to="/system/model" class="sub-item">
                <Icon icon="heroicons:cpu-chip" width="18" height="18" />
                <span>创作模型</span>
              </router-link>
              <router-link v-if="moduleStatus.media_model === 2" to="/system/medium-api" class="sub-item">
                <Icon icon="heroicons:camera" width="18" height="18" />
                <span>媒体模型</span>
              </router-link>
              <router-link to="/system/command" class="sub-item">
                <Icon icon="heroicons:command-line" width="18" height="18" />
                <span>创作指令</span>
              </router-link>
              <router-link v-if="moduleStatus.ai_agent === 2" to="/system/clever" class="sub-item">
                <Icon icon="heroicons:sparkles" width="18" height="18" />
                <span>AI智能体</span>
              </router-link>
              <router-link v-if="moduleStatus.storage_config === 2" to="/system/OssConfig" class="sub-item">
                <Icon icon="heroicons:folder" width="18" height="18" />
                <span>存储配置</span>
              </router-link>
              <router-link to="/system/publish" class="sub-item">
                <Icon icon="heroicons:globe-alt" width="18" height="18" />
                <span>基础设置</span>
              </router-link>
            </div>
          </div>
        </nav>
      </div>
    </aside>

    <!-- 主内容区 -->
    <main class="main-content">
      <!-- 顶部导航栏 -->
      <header class="top-header">
        <!-- 移动端显示折叠按钮 -->
        <div class="mobile-stats-btn" v-if="isMobile" @click="toggleMobileStats">
          <Icon icon="heroicons:chart-bar" width="20" height="20" />
        </div>

        <div class="header-right">
          <!-- PC端正常显示，移动端可折叠显示 -->
          <div class="stats-container" :class="{ 'mobile-collapsed': isMobile && !mobileStatsOpen }">
            <div class="stat-card">
              <Icon icon="heroicons:star" width="16" height="16" class="stat-icon purple" />
              <div class="stat-info">
                <span class="stat-label">点数</span>
                <span class="stat-value">{{ points === -1 ? '无限制' : points.toFixed(1) }}</span>
              </div>
            </div>
            <div class="stat-card">
              <Icon icon="heroicons:key" width="16" height="16" class="stat-icon green" />
              <div class="stat-info">
                <span class="stat-label">授权数</span>
                <span class="stat-value">{{ sqNum === -1 ? '无限制' : sqNum }}</span>
              </div>
            </div>
            <div class="stat-card">
              <Icon icon="heroicons:calendar" width="16" height="16" class="stat-icon orange" />
              <div class="stat-info">
                <span class="stat-label">过期时间</span>
                <span class="stat-value">{{ formattedOutDate }}</span>
              </div>
            </div>
          </div>

          <div class="user-section">
            <el-dropdown trigger="hover" placement="bottom-end">
              <div class="user-info">
                <div class="avatar">
                  <Icon icon="heroicons:user-circle" width="32" height="32" />
                </div>
                <span class="username">{{ username }}</span>
                <Icon icon="heroicons:chevron-down" width="14" height="14" class="dropdown-icon" />
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item @click="showCardRechargeDialog">
                    <Icon icon="heroicons:credit-card" width="16" height="16" />
                    <span>卡密充值</span>
                  </el-dropdown-item>
                  <el-dropdown-item @click="handleModifyPassword">
                    <Icon icon="heroicons:key" width="16" height="16" />
                    <span>修改密码</span>
                  </el-dropdown-item>
                  <el-dropdown-item divided @click="handleLogout">
                    <Icon icon="heroicons:arrow-right-start-on-rectangle" width="16" height="16" />
                    <span>退出登录</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
        </div>

        <!-- 移动端统计信息下拉面板 -->
        <div class="mobile-stats-panel" v-if="isMobile && mobileStatsOpen" @click.stop>
          <div class="stat-card-mobile">
            <Icon icon="heroicons:star" width="18" height="18" class="stat-icon purple" />
            <div class="stat-info">
              <span class="stat-label">点数</span>
              <span class="stat-value">{{ points === -1 ? '无限制' : points.toFixed(1) }}</span>
            </div>
          </div>
          <div class="stat-card-mobile">
            <Icon icon="heroicons:key" width="18" height="18" class="stat-icon green" />
            <div class="stat-info">
              <span class="stat-label">授权数</span>
              <span class="stat-value">{{ sqNum === -1 ? '无限制' : sqNum }}</span>
            </div>
          </div>
          <div class="stat-card-mobile">
            <Icon icon="heroicons:calendar" width="18" height="18" class="stat-icon orange" />
            <div class="stat-info">
              <span class="stat-label">过期时间</span>
              <span class="stat-value">{{ formattedOutDate }}</span>
            </div>
          </div>
        </div>
      </header>

      <!-- 页面内容 -->
      <div class="page-container">
        <router-view />
      </div>
    </main>

    <!-- 卡密充值弹窗 -->
    <el-dialog v-model="showCardDialog" title="卡密充值" width="400px" :close-on-click-modal="false" class="tech-dialog">
      <el-form :model="cardForm" label-width="80px">
        <el-form-item label="卡密">
          <el-input v-model="cardForm.code" placeholder="请输入充值卡密" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showCardDialog = false">取消</el-button>
        <el-button type="primary" @click="submitCardRecharge">确定</el-button>
      </template>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog v-model="showPasswordDialog" title="修改密码" width="400px" :close-on-click-modal="false"
      class="tech-dialog">
      <el-form :model="form" label-width="80px">
        <el-form-item label="旧密码">
          <el-input v-model="form.oldPwd" type="password" placeholder="请输入旧密码" show-password />
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="form.newPwd" type="password" placeholder="请输入新密码" show-password />
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input v-model="form.confirmPwd" type="password" placeholder="请再次输入新密码" show-password />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showPasswordDialog = false">取消</el-button>
        <el-button type="primary" @click="submitPassword">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, reactive } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import axios from 'axios'
import config from '@/config'
import { Icon } from '@iconify/vue'

export default {
  name: 'MainLayout',
  components: { Icon },
  setup() {
    const router = useRouter()
    const route = useRoute()

    const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
    const account = userInfo.account || ''
    const isCollapse = ref(false)
    const isMobile = ref(false)
    const mobileMenuOpen = ref(false)
    const mobileStatsOpen = ref(false)
    const hoverMenu = ref(null)
    const expandedMenus = ref(['account', 'seo'])
    const points = ref(0)
    const sqNum = ref(0)
    const outDate = ref('')
    const shopName = ref('商户端')
    const username = ref(account)
    const shopLogo = ref('')

    const moduleStatus = ref({
      writing_model: 2,
      media_model: 2,
      ai_agent: 2,
      storage_config: 2
    })

    const showPasswordDialog = ref(false)
    const showCardDialog = ref(false)
    const cardForm = reactive({ code: '' })
    const form = reactive({ oldPwd: '', newPwd: '', confirmPwd: '' })

    const formattedOutDate = computed(() => outDate.value.split(' ')[0] || '未设置')

    const activeMenu = computed(() => {
      const matched = route.matched
      return matched.length > 1 ? `/${matched[0].path.split('/')[1]}` : route.path
    })

    const toggleCollapse = () => {
      isCollapse.value = !isCollapse.value
    }

    const toggleSubMenu = (menu) => {
      if (!isCollapse.value) {
        if (expandedMenus.value.includes(menu)) {
          expandedMenus.value = expandedMenus.value.filter(m => m !== menu)
        } else {
          expandedMenus.value.push(menu)
        }
      }
    }

    const handleMouseEnter = (menu) => {
      if (isCollapse.value) {
        hoverMenu.value = menu
      }
    }

    const handleMouseLeave = () => {
      if (isCollapse.value) {
        hoverMenu.value = null
      }
    }

    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
    }

    const closeMobileMenu = () => {
      mobileMenuOpen.value = false
    }

    const toggleMobileStats = () => {
      mobileStatsOpen.value = !mobileStatsOpen.value
    }

    const checkMobile = () => {
      isMobile.value = window.innerWidth <= 768
      if (!isMobile.value) {
        closeMobileMenu()
        mobileStatsOpen.value = false
      }
    }

    // 点击外部关闭移动端统计面板
    const handleClickOutside = (event) => {
      if (isMobile.value && mobileStatsOpen.value) {
        const header = document.querySelector('.top-header')
        if (header && !header.contains(event.target)) {
          mobileStatsOpen.value = false
        }
      }
    }

    const loadPoints = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'query',
          account: account
        })
        if (response.data.success) {
          points.value = parseFloat(response.data.data.dianshu || 0)
          sqNum.value = parseInt(response.data.data.sq_num) || 0
          outDate.value = response.data.data.out_date || ''
        }
      } catch (error) {
        console.error('加载点数失败:', error)
      }
    }

    // 修改 loadShopInfo 方法
    const loadShopInfo = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`)
        if (response.data.success && response.data.data.shop_name) {
          shopName.value = response.data.data.shop_name
        }
        // 获取 logo 图片
        if (response.data.success && response.data.data.shop_logo) {
          shopLogo.value = response.data.data.shop_logo
        }
      } catch (error) {
        console.error('加载店铺信息失败:', error)
      }
    }

    const fetchModuleStatus = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/module_hidden.php`, {
          store_id: userInfo.id
        })
        if (response.data.data) {
          moduleStatus.value = response.data.data
        }
      } catch (error) {
        console.error('获取模块权限失败:', error)
      }
    }

    const showCardRechargeDialog = () => {
      cardForm.code = ''
      showCardDialog.value = true
    }

    const submitCardRecharge = async () => {
      if (!cardForm.code) {
        ElMessage.error('请输入卡密')
        return
      }
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'recharge_card',
          account: account,
          code: cardForm.code
        })
        if (response.data.success) {
          ElMessage.success('充值成功')
          await loadPoints()
          showCardDialog.value = false
        } else {
          ElMessage.error(response.data.message || '充值失败')
        }
      } catch (error) {
        ElMessage.error('请求失败')
      }
    }

    const handleModifyPassword = () => {
      Object.assign(form, { oldPwd: '', newPwd: '', confirmPwd: '' })
      showPasswordDialog.value = true
    }

    const submitPassword = async () => {
      if (!form.oldPwd) {
        ElMessage.error('请输入旧密码')
        return
      }
      if (!form.newPwd) {
        ElMessage.error('请输入新密码')
        return
      }
      if (form.newPwd !== form.confirmPwd) {
        ElMessage.error('两次输入的新密码不一致')
        return
      }
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'update_password',
          account: account,
          old_password: form.oldPwd,
          new_password: form.newPwd
        })
        if (response.data.success) {
          ElMessage.success('密码修改成功，请重新登录')
          Cookies.remove('user_token')
          router.push('/login')
        } else {
          ElMessage.error(response.data.message || '密码修改失败')
        }
      } catch (error) {
        ElMessage.error('请求失败')
      } finally {
        showPasswordDialog.value = false
      }
    }

    const handleLogout = async () => {
      try {
        await ElMessageBox.confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        })
        Cookies.remove('user_token')
        Cookies.remove('user_info')
        router.push('/login')
        ElMessage.success('已安全退出')
      } catch (error) {
        // 取消退出
      }
    }

    onMounted(() => {
      loadPoints()
      loadShopInfo()
      fetchModuleStatus()
      checkMobile()
      window.addEventListener('resize', checkMobile)
      document.addEventListener('click', handleClickOutside)
    })

    onUnmounted(() => {
      window.removeEventListener('resize', checkMobile)
      document.removeEventListener('click', handleClickOutside)
    })

    return {
      isCollapse,
      isMobile,
      mobileMenuOpen,
      mobileStatsOpen,
      hoverMenu,
      expandedMenus,
      points,
      sqNum,
      shopName,
      username,
      moduleStatus,
      activeMenu,
      formattedOutDate,
      showPasswordDialog,
      showCardDialog,
      cardForm,
      form,
      shopLogo,
      toggleCollapse,
      toggleSubMenu,
      handleMouseEnter,
      handleMouseLeave,
      toggleMobileMenu,
      closeMobileMenu,
      toggleMobileStats,
      showCardRechargeDialog,
      submitCardRecharge,
      handleModifyPassword,
      submitPassword,
      handleLogout
    }
  }
}
</script>

<style lang="scss">
/* 全局样式 - 不使用 scoped */
.app {
  display: flex;
  min-height: 100vh;
  background: linear-gradient(135deg, #0f0c1f 0%, #1a1535 50%, #0d0b1a 100%);
  position: relative;
}

/* 移动端菜单按钮 */
.mobile-menu-btn {
  position: fixed;
  top: 16px;
  left: 16px;
  z-index: 1001;
  width: 44px;
  height: 44px;
  background: rgba(101, 70, 180, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid rgba(157, 78, 221, 0.3);
  color: #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);

  @media (min-width: 769px) {
    display: none;
  }
}

/* 侧边栏遮罩 */
.sidebar-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 998;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;

  &.show {
    opacity: 1;
    visibility: visible;
  }

  @media (min-width: 769px) {
    display: none;
  }
}

/* 侧边栏 */
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  width: 280px;
  background: rgba(18, 14, 33, 0.95);
  backdrop-filter: blur(20px);
  border-right: 1px solid rgba(157, 78, 221, 0.2);
  display: flex;
  flex-direction: column;
  z-index: 999;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  @media (max-width: 768px) {
    transform: translateX(-100%);

    &.mobile-open {
      transform: translateX(0);
    }
  }

  &.collapsed {
    width: 80px;
    overflow: visible;

    .logo-text {
      display: none;
    }

    .logo-area {
      justify-content: center;

      .logo-img {
        margin: 0 auto;
      }

      .logo-icon {
        margin: 0 auto;
      }
    }

    .nav-text {
      display: none;
    }

    .sub-arrow {
      display: none;
    }

    .nav-sub {
      position: relative;

      // 伪元素填补图标和二级菜单之间的缝隙
      &::after {
        content: '';
        position: absolute;
        left: 100%;
        top: 0;
        width: 8px;
        height: 100%;
        z-index: 1059;
        pointer-events: none;
      }

      .sub-menu {
        position: absolute;
        left: 100%;
        top: 0;
        z-index: 1060;
        background: rgba(26, 21, 53, 0.98);
        backdrop-filter: blur(20px);
        min-width: 200px;
        border-radius: 12px;
        padding: 8px;
        margin-left: 8px;
        border: 1px solid rgba(157, 78, 221, 0.3);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
        opacity: 0;
        visibility: hidden;
        transition: opacity 0.2s ease, visibility 0.2s ease;
        display: flex;
        flex-direction: column;
        gap: 2px;

        &.show {
          opacity: 1;
          visibility: visible;
        }

        .sub-item {
          padding: 10px 12px;
          white-space: nowrap;
        }
      }
    }

    .nav-container {
      overflow: visible;
    }
  }

  .sidebar-header {
    padding: 24px 20px;
    border-bottom: 1px solid rgba(157, 78, 221, 0.15);
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo-area {
      display: flex;
      align-items: center;
      gap: 12px;

      .logo-icon {
        width: 48px;
        height: 48px;
        background: linear-gradient(135deg, #6546b4 0%, #9d4edd 100%);
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        box-shadow: 0 8px 20px rgba(101, 70, 180, 0.3);
        flex-shrink: 0;
      }

      .logo-img {
        width: 48px;
        height: 48px;
        border-radius: 14px;
        object-fit: cover;
        box-shadow: 0 8px 20px rgba(101, 70, 180, 0.3);
        flex-shrink: 0;
      }

      .logo-text {
        font-size: 18px;
        font-weight: 600;
        background: linear-gradient(135deg, #fff 0%, #c084fc 100%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
        margin: 0;
        white-space: nowrap;
      }
    }

    .collapse-btn {
      width: 32px;
      height: 32px;
      background: rgba(157, 78, 221, 0.2);
      border: 1px solid rgba(157, 78, 221, 0.3);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: #c084fc;
      transition: all 0.2s;

      &:hover {
        background: rgba(157, 78, 221, 0.4);
        border-color: rgba(157, 78, 221, 0.6);
      }
    }
  }

  .nav-container {
    flex: 1;
    overflow-y: auto;
    padding: 20px 12px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(157, 78, 221, 0.1);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(157, 78, 221, 0.4);
      border-radius: 4px;
    }
  }

  .nav-menu {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .nav-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-radius: 12px;
    color: #a0a0c0;
    transition: all 0.2s;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: rgba(157, 78, 221, 0.2);
      color: #c084fc;
    }

    &.active {
      background: linear-gradient(135deg, rgba(101, 70, 180, 0.3), rgba(157, 78, 221, 0.2));
      color: #c084fc;
      border-left: 3px solid #9d4edd;
    }

    .nav-icon {
      flex-shrink: 0;
    }

    .nav-text {
      flex: 1;
      font-size: 14px;
      font-weight: 500;
    }

    .sub-arrow {
      flex-shrink: 0;
    }
  }

  .nav-sub {
    .sub-trigger {
      user-select: none;

      .sub-arrow {
        transition: transform 0.2s;
      }
    }

    &.expanded .sub-trigger .sub-arrow {
      transform: rotate(180deg);
    }

    .sub-menu {
      display: flex;
      flex-direction: column;
      gap: 2px;
      margin-left: 32px;
      margin-top: 4px;
      margin-bottom: 4px;

      .sub-item {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 12px;
        border-radius: 10px;
        color: #a0a0c0;
        text-decoration: none;
        font-size: 13px;
        transition: all 0.2s;

        &:hover {
          background: rgba(157, 78, 221, 0.15);
          color: #c084fc;
        }

        &.router-link-active {
          background: rgba(157, 78, 221, 0.2);
          color: #c084fc;
        }
      }
    }
  }
}

/* 主内容区 */
.main-content {
  flex: 1;
  margin-left: 280px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  min-width: 0;
  overflow-x: hidden;
  width: 100%;
  position: relative;
  z-index: 1;

  @media (max-width: 768px) {
    margin-left: 0;
  }

  .sidebar.collapsed~& {
    margin-left: 80px;

    @media (max-width: 768px) {
      margin-left: 0;
    }
  }
}

/* 顶部导航栏 */
.top-header {
  background: rgba(18, 14, 33, 0.8);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(157, 78, 221, 0.2);
  padding: 10px 24px;
  position: sticky;
  top: 0;
  z-index: 100;

  @media (max-width: 768px) {
    padding: 10px 16px;
    padding-left: 70px;
  }

  .mobile-stats-btn {
    position: absolute;
    left: 70px;
    top: 50%;
    transform: translateY(-50%);
    width: 36px;
    height: 36px;
    background: rgba(157, 78, 221, 0.15);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #c084fc;

    &:hover {
      background: rgba(157, 78, 221, 0.25);
    }
  }

  .header-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 24px;
  }

  .stats-container {
    display: flex;
    align-items: center;
    gap: 16px;
    transition: all 0.3s ease;

    @media (max-width: 768px) {
      position: fixed;
      top: 60px;
      right: 16px;
      flex-direction: column;
      gap: 8px;
      background: rgba(18, 14, 33, 0.98);
      backdrop-filter: blur(20px);
      border-radius: 12px;
      padding: 12px;
      border: 1px solid rgba(157, 78, 221, 0.3);
      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
      transform: translateX(0);
      opacity: 1;
      visibility: visible;
      z-index: 99;

      &.mobile-collapsed {
        transform: translateX(calc(100% + 16px));
        opacity: 0;
        visibility: hidden;
      }
    }

    .stat-card {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 14px;
      background: rgba(157, 78, 221, 0.1);
      border-radius: 10px;
      border: 1px solid rgba(157, 78, 221, 0.2);
      transition: all 0.2s;

      @media (max-width: 768px) {
        width: 100%;
        justify-content: center;
      }

      &:hover {
        background: rgba(157, 78, 221, 0.15);
        border-color: rgba(157, 78, 221, 0.4);
      }

      .stat-icon {
        flex-shrink: 0;

        &.purple {
          color: #9d4edd;
        }

        &.green {
          color: #10b981;
        }

        &.orange {
          color: #f59e0b;
        }
      }

      .stat-info {
        display: flex;
        flex-direction: column;

        .stat-label {
          font-size: 10px;
          color: #7a7a9a;
          letter-spacing: 0.5px;
        }

        .stat-value {
          font-size: 13px;
          font-weight: 600;
          color: #fff;
        }
      }
    }
  }

  .user-section {
    flex-shrink: 0;

    .user-info {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 5px 12px;
      background: rgba(157, 78, 221, 0.1);
      border-radius: 40px;
      border: 1px solid rgba(157, 78, 221, 0.2);
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background: rgba(157, 78, 221, 0.15);
        border-color: rgba(157, 78, 221, 0.4);
      }

      .avatar {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9d4edd;
      }

      .username {
        font-size: 13px;
        font-weight: 500;
        color: #fff;

        @media (max-width: 768px) {
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .dropdown-icon {
        color: #7a7a9a;
      }
    }
  }
}

/* 移动端统计面板 */
.mobile-stats-panel {
  position: fixed;
  top: 60px;
  right: 16px;
  background: rgba(18, 14, 33, 0.98);
  backdrop-filter: blur(20px);
  border-radius: 12px;
  padding: 12px;
  border: 1px solid rgba(157, 78, 221, 0.3);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
  z-index: 99;
  min-width: 160px;

  .stat-card-mobile {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: rgba(157, 78, 221, 0.1);
    border-radius: 8px;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0;
    }

    .stat-icon {
      flex-shrink: 0;

      &.purple {
        color: #9d4edd;
      }

      &.green {
        color: #10b981;
      }

      &.orange {
        color: #f59e0b;
      }
    }

    .stat-info {
      flex: 1;

      .stat-label {
        font-size: 11px;
        color: #7a7a9a;
        display: block;
      }

      .stat-value {
        font-size: 14px;
        font-weight: 600;
        color: #fff;
      }
    }
  }
}

/* 页面容器 */
.page-container {
  flex: 1;
  padding: 24px;
  min-width: 0;
  overflow-x: auto;
  box-sizing: border-box;
  width: 100%;

  @media (max-width: 768px) {
    padding: 16px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
}

/* Element Plus 样式覆盖 */
.el-dialog {
  background: rgba(18, 14, 33, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(157, 78, 221, 0.3);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);

  .el-dialog__header {
    border-bottom: 1px solid rgba(157, 78, 221, 0.2);
    padding: 20px 24px;

    .el-dialog__title {
      color: #fff;
      font-weight: 600;
    }
  }

  .el-dialog__body {
    padding: 24px;
  }

  .el-dialog__footer {
    border-top: 1px solid rgba(157, 78, 221, 0.2);
    padding: 16px 24px;
  }
}

.el-form-item__label {
  color: #a0a0c0;
}

.el-input__wrapper {
  background: rgba(26, 21, 53, 0.8);
  border: 1px solid rgba(157, 78, 221, 0.3);
  box-shadow: none;

  &:hover {
    border-color: rgba(157, 78, 221, 0.6);
  }

  &.is-focus {
    border-color: #9d4edd;
    box-shadow: 0 0 0 2px rgba(157, 78, 221, 0.2);
  }

  .el-input__inner {
    color: #fff;
    background: transparent;
  }
}

.el-button {
  border-radius: 10px;
  padding: 10px 20px;
}

.el-button--default {
  background: rgba(157, 78, 221, 0.2);
  border-color: rgba(157, 78, 221, 0.4);
  color: #c084fc;

  &:hover {
    background: rgba(157, 78, 221, 0.3);
    border-color: rgba(157, 78, 221, 0.6);
  }
}

.el-button--primary {
  background: linear-gradient(135deg, #6546b4 0%, #9d4edd 100%);
  border: none;

  &:hover {
    background: linear-gradient(135deg, #7556c4 0%, #ad5eed 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 15px rgba(157, 78, 221, 0.4);
  }
}

.el-dropdown-menu {
  background: rgba(18, 14, 33, 0.98);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(157, 78, 221, 0.3);
  border-radius: 12px;
  padding: 8px;

  .el-dropdown-menu__item {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #a0a0c0;
    border-radius: 8px;

    &:hover {
      background: rgba(157, 78, 221, 0.2);
      color: #c084fc;
    }
  }
}
</style>